<div class="container-fluid p-3 m-0" [class.hide-pointer]="hidePointer">
    <div class="row pt-2 align-items-center">
        <div class="col-lg-9 col-12 d-flex flex-column" id="filters-container">
            <div class="d-flex flex-row align-items-center">
                <mat-icon *ngIf="filterDefinitions && filterDefinitions.length > 0" class="filter-icon">
                    filter_list
                </mat-icon>
                <app-data-table-filter *ngFor="let filterDefinition of filterDefinitions" class="filter"
                    [filterDefinition]="filterDefinition" [disable]="displayLoadingIndicator">
                    <ng-template #filters></ng-template>
                </app-data-table-filter>
            </div>
        </div>
        <!-- Search Bar -->
        <div class="col-lg-3 col-12 my-2" *ngIf="showSearch">
            <mat-form-field appearance="outline" class="search-bar">
                <mat-label class="search-bar-label">
                    <mat-icon class="search-icon">search</mat-icon>
                    <span>Search</span>
                </mat-label>
                <input matInput (keyup.enter)="onSearchEvent($event)" (keyup.backspace)="onDeleteKeyUp()"
                    [(ngModel)]="searchKeyword">
                <button type="button" *ngIf="searchKeyword" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
    <div class="row p-2 mx-2" *ngIf="selection.hasValue()">
        <div class="col-lg-9 col-12">
            <ng-container *ngIf="component === 'Reservations'">
                <button type="button" class="action-button" matSuffix mat-raised-button (click)="useMassStatusSelection(component, $event, selection)" style="margin-right:8px; display:inline-block">
                    <div>Cancel/Uncancel</div>
                </button>
                <button *ngIf="selection.selected.length === 1 || orgFilterActive || allowPropertyReservationUpdateBoolean" type="button" class="action-button" matSuffix mat-raised-button (click)="useMassPolicySelection(component, $event, selection)" style="display:inline-block">
                    <div>
                        Update Insurance Polic<span *ngIf="selection.selected.length === 1">y</span><span *ngIf="selection.selected.length > 1">ies</span>
                    </div>
                </button>
            </ng-container>
            <ng-container *ngIf="component === 'Properties'">
                <button type="button" class="action-button" matSuffix mat-raised-button (click)="useMassStatusSelection(component, $event, selection)" style="margin-right:8px; display:inline-block">
                    <div>
                        Update Status<span *ngIf="selection.selected.length > 1">es</span>
                    </div>
                </button>
                <button *ngIf="selection.selected.length === 1 || orgFilterActive" type="button" class="action-button" matSuffix mat-raised-button (click)="useMassPolicySelection(component, $event, selection)" style="display:inline-block">
                    <div>
                        Update Insurance Polic<span *ngIf="selection.selected.length === 1">y</span><span *ngIf="selection.selected.length > 1">ies</span>
                    </div>
                </button>
            </ng-container>
        </div>
    </div>
    <div class="d-flex flex-row align-items-center pt-2" id="filter-pills-container">
        <app-data-table-filter-pill *ngFor="let filterPill of filterPills | keyvalue" [filterState]="filterPill.value"
            (closeClickEvent)="onFilterPillCloseEvent($event)" [disable]="displayLoadingIndicator">
        </app-data-table-filter-pill>
    </div>
    <div class="mt-2 mb-3">
        <div class="table-responsive">
            <table mat-table class="table" matSort [matSortDisabled]="disableSorting" [dataSource]="_dataSource" (matSortChange)="onSortEvent($event)" matSortDisableClear>
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            [aria-label]="checkboxLabel()" [color]="'primary'">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)" [color]="'primary'">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                    <ng-container *ngIf="column.column !== 'action'">
                        <ng-container *ngIf="column.disableSorting; else sortable">
                            <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                        </ng-container>
                        <ng-template #sortable>
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.display }}</th>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="column.column === 'action'">
                        <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                    </ng-container>

                    <ng-container [ngSwitch]="column.column">
                        <ng-container *ngSwitchCase="'action'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]">
                                    <button mat-raised-button 
                                        [style.backgroundColor]="getActionButtonColor && getActionButtonColor(element) + '!important'"
                                        [style.color]="'white'"
                                        (click)="onActionButtonClick($event, element)"
                                        class="d-flex align-items-center">
                                        @if(getActionButtonIcon && getActionButtonIcon(element)) {
                                            <mat-icon>{{ getActionButtonIcon(element) }}</mat-icon>
                                        }

                                        @if(getCalculatedActionButtonText) {
                                            {{ getCalculatedActionButtonText(element) }}
                                        } @else {
                                            {{ actionButtonText }}
                                        }
                                    </button>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'pillStatus'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]">
                                    <app-pill 
                                        [backgroundColor]="this.getColor(element[column.column])"
                                        fontColor="white"
                                        [text]="element[column.column]"></app-pill>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'primaryStatus'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]">
                                    <app-pill 
                                        [backgroundColor]="this.getColor(element[column.column])"
                                        fontColor="white"
                                        [text]="element[column.column]"></app-pill>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'price'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]==='View Night Ranges'; else priceDefault">
                                    <span class="view-range" (click)="onActionButtonClick($event, element)">
                                        {{ element[column.column] }}</span>
                                </ng-container>
                                <ng-template #priceDefault>{{ element[column.column] }}</ng-template>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'verificationPackagesButtons'">
                            <td mat-cell *matCellDef="let element" style="width:14%;">
                                <button mat-mini-fab class="edit-table-action-button" (click)="onEditVerificationPackageButtonClick($event, element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-mini-fab class="edit-table-action-button" (click)="onUpdatePrimaryVerificationPackageClick($event, element)" [ngClass]="{'set': element.pillStatus === ''}" [disabled]="tableLength === 1">
                                    <mat-icon>indeterminate_check_box</mat-icon>
                                </button>
                                <button mat-mini-fab class="delete-table-action-button" (click)="onDeleteVerificationPackageButtonClick($event, element)" [disabled]="tableLength === 1">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'policyUnderwriterButtons'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab class="edit-table-action-button" (click)="onEditPolicyUnderwriterButtonClick($event, element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-mini-fab class="delete-table-action-button" (click)="onDeletePolicyUnderwriterButtonClick($event, element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'verificationCheckTypeButtons'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab class="delete-table-action-button" (click)="onDeleteVerificationCheckTypeButtonClick($event, element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'underwriterButtons'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab class="edit-table-action-button" (click)="onEditUnderwriterButtonClick($event, element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-mini-fab class="delete-table-action-button" (click)="onDeleteUnderwriterButtonClick($event, element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencyButtons'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab class="edit-table-action-button" (click)="onEditCurrencyButtonClick($event, element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-mini-fab class="delete-table-action-button" (click)="onDeleteCurrencyButtonClick($event, element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'badGuestButtons'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-mini-fab class="edit-table-action-button" (click)="onEditBadGuestButtonClick($event, element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-mini-fab class="delete-table-action-button" (click)="onDeleteBadGuestButtonClick($event, element)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'reservationFormSelectPropertyButton'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-raised-button class="edit-table-action-button" (click)="onReservationFormSelectProperty($event, element)">
                                    Select Property
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            @if(column.renderHtml) {
                            <td mat-cell *matCellDef="let element" [innerHTML]="element[column.column]"></td>
                            } @else {
                            <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                            }
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnNames;" (click)="onRowClick(row)"></tr>
                @if(displayLoadingIndicator.value){
                    <tr class="mat-row" *matNoDataRow style="border:0px solid white;">
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            @if(searchKeyword) {
                                No data matching the filter "{{ searchKeyword }}"
                            } @else {
                                @if(tableLength === 0) {
                                    No {{ component }} Data
                                } @else {
                                    Loading {{ component }}..
                                }
                            }
                        </td>
                    </tr>
                } @else {
                    <div class="d-flex justify-content-center">
                        <mat-spinner></mat-spinner>
                    </div>
                }
                <ng-container *ngIf="!displayLoadingIndicator.value">
                    <tr class="mat-row" *matNoDataRow style="border:0px solid white;">
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            @if(searchKeyword) {
                                No data matching the filter "{{ searchKeyword }}"
                            } @else {
                                @if(tableLength === 0) {
                                    No {{ component }} Data
                                } @else {
                                    Loading {{ component }}..
                                }
                            }
                        </td>
                    </tr>
                </ng-container>
            </table>
        </div>
        <div *ngIf="displayLoadingIndicator.value" class="d-flex justify-content-center">
            <mat-spinner></mat-spinner>
        </div>
        <div class="d-flex paginator-row align-items-baseline" *ngIf="showPaginator">
            <div class="col-10">
                <mat-paginator (page)="onPageEvent($event)"
                    [pageSizeOptions]="this.disablePageSizeSelector ? [] : [10, 20, 50, 100]" [length]="tableLength"
                    [pageSize]="pageSize || 5" aria-label="Select page" showFirstLastButtons>
                </mat-paginator>
            </div>
            <div class="col-2 d-flex align-items-baseline">
                <mat-form-field class="go-to" id="goToPage">
                    <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber">
                </mat-form-field>
                <button mat-raised-button (click)="onGoToPageClick()" class="action-button">Go</button>
            </div>
        </div>
    </div>
</div>